 
var menuActive          = true;
var menuTextOutColor    = "#bdbdbd"; 
var urlCharDeeplink     = "#";
var touchDevice 		= 0;
var isOverMenu          = false;
var templateMenuW       = 0;

/*----------------- start menuListeners -------------------*/
var menuOptionsArr	= new Array();
function storeMenuArr(){
  var extraWidth = $(".template-menu").width() + $("#menu-hider").width();
  $("#template-menu").children().each(function(index, element){
    var menu = $(element),
        subOptArr = "null", 
        subHol = "null",
        menOptText = $(".menu-option-text a", menu);
    menuOptionsArr[ index ]         = [];
    menuOptionsArr[ index ][ 0 ]    = menu;
    
    if( menu.attr("data-module-type") == undefined ){
      var subMenu = [];
      subHol = menu.find(".sub-menu-holder");
      subHol.children().each(function(index, elem){
        var submenu = $(elem),
            subOptTxt = $(".sub-menu-option-text a", this),
            subOptHref = String(subOptTxt.attr("href")),
            subOptHrefPath = subOptTxt.attr("data-path-href");
        subMenu[ index ] = [];
        subMenu[ index ][ 0 ] = urlCharDeeplink + menOptText.text().toLowerCase() + "/" + subOptHref.replace(urlCharDeeplink,"");
        subMenu[ index ][ 1 ] = [submenu.attr("data-module-type"), submenu.attr("data-side"),  subOptHref.replace(urlCharDeeplink,""), subOptHrefPath];
        subMenu[ index ][ 2 ] = $(".sub-menu-option-background", this);
        subMenu[ index ][ 3 ] = subOptTxt;    
      });
      subOptArr = subMenu; 
      menuOptionsArr[ index ][ 1 ] = "null";                  
    }
    else{
      menuOptionsArr[ index ][ 1 ]    = [menu.attr("data-module-type"), menu.attr("data-side"),  String(menOptText.attr("href")).replace(urlCharDeeplink,""), menOptText.attr("data-path-href")];   
    }                      
    menuOptionsArr[ index ][ 2 ]    = $(".menu-option-background", menu);
    menuOptionsArr[ index ][ 3 ]    = ( subOptArr == "null" ) ? [menOptText] : [menOptText, $(".menu-option-text div", menu)];
    menuOptionsArr[ index ][ 4 ]    = extraWidth - parseInt( menOptText.css("padding-left"), 10);
    menuOptionsArr[ index ][ 5 ]    = subHol;  
    menuOptionsArr[ index ][ 6 ]    = subOptArr;            
    if( touchDevice == 0 )menu.bind("mouseenter mouseleave", {idx: index}, menuOptionHover);
  });	
}

function menuOptionHover( event ){
  var idx = event.data.idx,
      subMenuHol = menuOptionsArr[ idx ][ 5 ];
  if( event.type == "mouseenter" ){
    menuOptionsArr[ idx ][ 3 ][ 0 ].css("width", menuOptionsArr[ idx ][ 4 ]); 
    TweenMax.to( menuOptionsArr[ idx ][ 2 ], menuAnimDuration, { css:{marginLeft: "0px", width: menuWidth}, ease:menuAnimEase });
    TweenMax.to( menuOptionsArr[ idx ][ 3 ], menuAnimDuration, { css:{color: "#FFF"}, ease:menuAnimEase });  
    
    if( subMenuHol != "null" ){
      subMenuHol.css( 'height', '').css( 'width', '');
      var initialHeight = subMenuHol.css( 'height'),
          initialWidth  = subMenuHol.css( 'width');
      subMenuHol.css( 'width', '0px' ).css( 'height', '0px' );                
      TweenMax.to( subMenuHol, menuAnimDuration, { css:{height:initialHeight, width:initialWidth}, delay:0.2, ease:menuAnimEase, onStart:
                                                  function(){
                                                    subMenuHol.css( 'opacity', '1' ).css( 'display', 'block' );
                                                  }
                                                 });   
    }   
  }
  else{
    menuOptionsArr[ idx ][ 3 ][ 0 ].css("width", ""); 
    if( menuOptionsArr[ idx ][ 2 ].hasClass('menu-option-background-selected') == false ){
      TweenMax.to( menuOptionsArr[ idx ][ 2 ], menuAnimDuration, { css:{marginLeft: menuWidth, width: "0px"}, ease:menuAnimEase });
      TweenMax.to( menuOptionsArr[ idx ][ 3 ], menuAnimDuration, { css:{color: menuTextOutColor}, ease:menuAnimEase });
    }
    if( subMenuHol != "null" ){
      subMenuHol.css( 'overflow', '' );
      TweenMax.killTweensOf( subMenuHol );
      TweenMax.to( subMenuHol, menuAnimDuration, { css:{height:"0px", width:"0px" }, ease:menuAnimEase, onComplete:hideSubmenu, onCompleteParams:[subMenuHol]});
    }                       
  } 
}
function hideSubmenu( obj ){ obj.css( 'opacity', '0' ).css( 'display', 'none' ); }

var menuAnimEase       = Quad.easeOut; /* Circ.easeOut  Quad.easeOut*/
var menuAnimDuration   = 0.4; /* 0.6  or  0.3*/
var menuWidth = 0;    
var submenuWidth = 0;
function menuListeners(){	
  menuWidth = $(".template-menu").width() + "px";
  /* We add 2 px in order to fix the 2px margin on the right. Since sub menu holder */
  /* has overflow hidden the 2px will fill the gap in IE 8 and in the other browser it won't be shown. */
  submenuWidth = $(".template-menu").width() + 2 + "px";
  /* MENU & SUBMENU -- OVER & OUT LISTENER */
  
  function hideSubmenu( obj ){ obj.css( 'opacity', '0' ).css( 'display', 'none' ); }
  var submOptBackSel = "sub-menu-option-background-selected"; 		
  if( touchDevice == 0 )$(".sub-menu-option-holder").hover(
    function(){	 
      var submOptBack = $(".sub-menu-option-background", this);
      var elem = submOptBack.length == 1  ? submOptBack : $("." + submOptBackSel, this);
      TweenMax.to( elem, menuAnimDuration, { css:{marginLeft:"0px", width: submenuWidth}, ease:menuAnimEase });
      TweenMax.to( $(".sub-menu-option-text a", this), menuAnimDuration, { css:{color:"#FFF"}, ease:menuAnimEase });
    }, 
    function(){
      if( $('div:first', this ).hasClass(submOptBackSel) == false ){
        var submOptBack = $(".sub-menu-option-background", this);
        var elem = submOptBack.length == 1  ? submOptBack : $("." + submOptBackSel, this);
        TweenMax.to( elem, menuAnimDuration, { css:{marginLeft: submenuWidth, width:"0px"}, ease:menuAnimEase });
        TweenMax.to( $(".sub-menu-option-text a", this), menuAnimDuration, { css:{color: menuTextOutColor}, ease:menuAnimEase });
      } 
    });	
}

/* activate hover menu */
function activateHoverMenu(){      
  $("#menu-container").bind( "mouseenter", overMenu );
  $("#menu-hider-icon").bind( "mouseenter", menuHiderOver );
  $("#menu-hider-icon").bind( "mouseleave", menuHiderOver );
  $("#menu-container").bind( "mouseleave", outMenu );
}
/* menu hider over */
function menuHiderOver(event){
  event.stopPropagation();
}
/* disable hover menu */
function disableHoverMenu(){
  $("#menu-container").unbind( "mouseenter", overMenu );
  $("#menu-hider-icon").unbind( "mouseenter", menuHiderOver );
  $("#menu-hider-icon").unbind( "mouseleave", menuHiderOver );
  $("#menu-container").unbind( "mouseleave", outMenu );
}

/* over menu */
function overMenu(){
  if( menuActive == true) return;
  isOverMenu = true;
  TweenMax.to( $("#template-wrapper"), .4, { css:{left: "0px", top:"0px"}, ease:Sine.easeInOut });
  TweenMax.to( $("#menu-container"), .4, { css:{left: "0px", top:"0px"}, ease:Sine.easeInOut });
  totalUpdate();
}
/* out menu */
function outMenu(){
	if( menuActive == true) return;
	isOverMenu = false;        
	var winW = $(window).width(),
		winH = $(window).height();
	if(winW >= 768){
		var menuWidth = parseInt( $("#menu-container").css("width"), 10 ) - parseInt($("#menu-hider").width(), 10),
			menuVal = 0;
		TweenMax.to( $("#template-wrapper"), .4, { css:{left: -(menuWidth ) + "px", top:"0px"}, ease:Sine.easeInOut });
		TweenMax.to( $("#menu-container"), .4, { css:{left: menuVal + "px", top:"0px"}, ease:Sine.easeInOut });    
	}else{
		var menuHiderH = parseInt( $("#menu-container #menu-hider").height(), 10 ),
			menuHeight = parseInt( $("#menu-container").css("height"), 10 ) - menuHiderH,
			menuVal = 0;
		
		TweenMax.to( $("#template-wrapper"), .4, { css:{top: -(menuHeight ) + "px", left: "0px"}, ease:Sine.easeInOut });
		disableHoverMenu();
		TweenMax.to( $("#menu-container"), .4, { css:{top: menuVal + "px", left: "0px"}, ease:Sine.easeInOut, onComplete:function()
			{if(touchDevice == 0)activateHoverMenu();} 
		});
	}     
	totalUpdate();
}

/* total update */
function totalUpdate(){
  alwaysUpdate();
  
  var delayUpdateCallback = '';       
  delayUpdateCallback = setInterval(function(){            
    
    updateCallback();
                               
    clearInterval( delayUpdateCallback );            
  }, 50);
}

/* always update */
function alwaysUpdate(){
  
  var winW = $(window).width();
  var winH = $(window).height();
  var newModContW =  winW - get_OffsetWidth();
  var newModContH =  winH;
  var cModuleType = $("#template-menu").attr("data-current-module-type");
  var menuWidth = parseInt( $("#menu-container .menu-content-holder").css("width"), 10 );
  var menuHider = parseInt( $("#menu-container #menu-hider").width(), 10 );
  if( winW < 768 ){
    var menuHiderH = parseInt( $("#menu-container #menu-hider").height(), 10 ),
        menuHeight = winH  - menuHiderH;                    
    newModContH  = menuHeight;
    
    var offsetHeight = ( menuActive == true ) ? parseInt( $("#menu-container").height(), 10 ) - menuHiderH : 0;
    newModContH = newModContH - offsetHeight;
    
    $("#template-wrapper").css('left', '0px');
    $("#module-container").css("width", newModContW + "px").css("left", menuWidth + menuHider + "px");
    $("#module-content").css("height", get_OffsetHeight() + "px");
  }
  else{
    TweenMax.to( $("#module-container"), .0, { css:{width: newModContW + "px"}, ease:Sine.easeInOut });
    $("#module-container").css("left", menuWidth + menuHider + "px");
    $("#module-content").css("height", get_OffsetHeight() + "px");
  }
}

/* settings for screen resolutions */ 
function settingsForScreens(){
  $("body").css("visibility", "visible" );
  var menuWidth = parseInt( $("#menu-container .menu-content-holder").css("width"), 10 );
  var menuHider = parseInt( $("#menu-container #menu-hider").width(), 10 );
  var menuHiderIcon = parseInt( $("#menu-container #menu-hider #menu-hider-icon").width(), 10 ); 
  var menuHeight = parseInt( $("#menu-container").css("height"), 10 );
  
  var menuHiderH = parseInt( $("#menu-container #menu-hider").height(), 10 );
  var menuHiderIconH = parseInt( $("#menu-container #menu-hider #menu-hider-icon").height(), 10 );       
  templateMenuW = menuWidth + menuHider;
  $("#menu-hider-icon").click(menuHideClick);        
  $("#module-container").css( "width", ($(window).width() - templateMenuW) + "px" );
  $("#module-content").css("height", get_OffsetHeight() + "px");
  
  if( $(window).width() > 767){
    $("#menu-container").css('left', -(menuWidth + menuHider + menuHiderIcon) + 'px');
    $("#menu-container").css( 'visibility', 'visible' );
    
    $("#menu-hider").css( 'display', 'inline' );
    $("#menu-hider").css( 'visibility', 'visible' );
    
    /*start-up animation*/            
    $("#module-container").css( "opacity", 1 );
    $("#module-container").css( "left", menuWidth + menuHider + "px" );
    
    $("footer").css( 'display', 'inline' );
    TweenMax.to( $("#menu-container"), 0.0, { css:{left: "0px"}, ease:Sine.easeInOut, delay: 0, onComplete: endStartupAnimation });
    /*end start-up animation*/
  }
  if( $(window).width() <= 767 ){            
    templateMenuW = 0;
    var containerH = $(window).height() - (menuHeight + menuHiderH);
    $("#menu-container").css("left", "0px");
    $("#menu-container").css("top", -(menuHeight + menuHiderH + menuHiderIconH) + "px");
    $("#menu-container").css( "visibility", "visible" );
    
    $("#menu-hider").css( "display", "inline" );
    $("#menu-hider").css( "visibility", "visible" );
    
    /*start-up animation*/
    $("#module-container").css( "opacity", "1" );
    $("#module-container").css( "left", "0px" );
    $("#module-container").css( "top", (menuHeight + menuHiderH) + "px" );
    
    TweenMax.to( $("#menu-container"), .4, { css:{top: "0px"}, ease:Sine.easeInOut, delay: 0.5, onComplete: endStartupAnimation });
    /*end start-up animation*/
  }
}

function get_OffsetWidth(){
  var value = 0;   
  if( $(window).width() > 767 ){
    if( menuActive == false ){
      if( isOverMenu == false )
        value = parseInt( $("#menu-hider").css("width"), 10 );
      else
        value = parseInt( $("#menu-container").css("width"), 10 );    
    }
    else{ value = parseInt( $("#menu-container").css("width"), 10 ); }
  }     
  return value;
}

function get_OffsetHeight(){
  var value = 0;   
  var headerHeight = $('#header').outerHeight();
  value = getHeightBrowser() - headerHeight;
  return value;
}

/*menu hide click*/
function menuHideClick(){
	var winW = $(window).width(),
		winH = $(window).height();
	if( menuActive == true ){
		menuActive = false;
        totalUpdate();
		if( winW >= 768 ){
			var menuHider = ($("#menu-hider").length > 0 ) ? parseInt($("#menu-hider").width(), 10) : 0,
				menuWidth = parseInt( $("#menu-container").css("width"), 10 ) - menuHider,
				menuVal = 0;         
			TweenMax.to( $("#template-wrapper"), .4, { css:{left: -(menuWidth ) + "px"}, ease:Sine.easeInOut });
			TweenMax.to( $("#menu-container"), .4, { css:{left: menuVal + "px"}, ease:Sine.easeInOut, onComplete:function()
				{if(touchDevice == 0)activateHoverMenu();} 
			});    
		}
		else{
			var menuHiderH = parseInt( $("#menu-container #menu-hider").height(), 10 ),
				menuHeight = parseInt( $("#menu-container").css("height"), 10 ) - menuHiderH,
				menuVal = 0;
			
			TweenMax.to( $("#template-wrapper"), .4, { css:{top: -(menuHeight ) + "px"}, ease:Sine.easeInOut });
			TweenMax.to( $("#menu-container"), .4, { css:{top: menuVal + "px"}, ease:Sine.easeInOut, onComplete:function()
				{if(touchDevice == 0)activateHoverMenu();} 
			});
		}
	}
	else{
		if(touchDevice == 0)disableHoverMenu();
		menuActive = true;
		isOverMenu = false;
		totalUpdate();
		TweenMax.to( $("#template-wrapper"), .4, { css:{left: "0px", top: "0px"}, ease:Sine.easeInOut });
		TweenMax.to( $("#menu-container"), .4, { css:{left: "0px"}, top: "0px", ease:Sine.easeInOut });
	}        
	
}

var delayInterval = "";
function endStartupAnimation(){
  templateFirstRunDone = true;       
  delayInterval = setInterval(function(){            
    //showModule();
    clearInterval( delayInterval );            
  }, 200);
}

jQuery(document).ready(function($){
  
  storeMenuArr();            
  menuListeners();
  settingsForScreens();

});